module.exports = __webpack_public_path__ + "static/benecaid-logo-2d793d9a7c9ae5c77465e141b7a6604b.png";